import React from "react"
import { css } from "@emotion/core"

import Layout from "../components/layout"
import BlogPostCard from "../components/blog-post-card"
import FilterToggle from "../components/filter-toggle"
import Tag from "../components/tag"
import SEO from "../components/seo"

export default function Blog({ data }) {
  const [checked, setChecked] = React.useState(false)
  const [state, setState] = React.useState({
    allPosts: data.allMdx.edges,
    filteredData: [],
    query: {},
  })

  const posts = state.filteredData.length ? state.filteredData : state.allPosts

  return (
    <Layout>
      <SEO title="Portfolio" />
      <h1
        css={css`
          display: inline-block;
          padding-bottom: 10px;
        `}
      >
        Portfolio
      </h1>
      <FilterToggle checked={checked} setChecked={setChecked} />
      <h5
        css={css`
          display: inline-block;
          margin-top: 8.5px;
          margin-right: 10px;
          color: var(--color-off-text);
          float: right;
        `}
      >
        {data.allMdx.totalCount}{" Posts"}
      </h5>
      <h5
        css={css`
          display: ${state.filteredData.length ? "inline-block" : "none"};;
          margin-top: 8.5px;
          margin-right: 5px;
          color: var(--color-off-text);
          float: right;
        `}
      >
        {" ( filtered ) "}{state.filteredData.length}{" /"}
      </h5>
      <ul
        css={css`
          display: ${checked ? "block" : "none"};
          list-style-type: none;
          margin: 0;
          margin-bottom: 20px;
        `}
      >
        <label
          css={css`
            margin-right: 20px;
            font-weight: bold;
          `}
        >
          Tags:
        </label>
        {data.tagsGroup.group.map(({ fieldValue }) => (
          <Tag tag={fieldValue} setState={setState} state={state} />
        ))}
      </ul>
      <p
        css={css`
          margin-bottom: 30px;
        `}
      >
        Here you'll find the projects I have worked on in the past, or that I'm currently working on. Click the filter icon to see the different subjects.
      </p>
      <section
        css={css`
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
          grid-gap: 50px;
        `}
      >
        {posts.map(({ node }) => (
          <BlogPostCard node={node} />
        ))}
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMdx(
        sort: { fields: [frontmatter___date], order: DESC },
        filter: {fileAbsolutePath: {regex: "/content\/portfolio/"}}
      ) {
      totalCount
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            date(formatString: "DD/MM/YYYY")
            description
            tags
            thumbnail {
              childImageSharp {
                fluid(maxWidth: 1200) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
    tagsGroup: allMdx(limit: 2000) {
      group(field: frontmatter___tags) {
        fieldValue
      }
    }
  }
`
